module.exports = __webpack_public_path__ + "media/images/az-9441a5da6b52fd21798f6e8f281c7cd8.png";